export const PAYMENT_BACK_REDIRECT_PARAM = 'backRedirect';
